
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.875 22.5H22.5a1.875 1.875 0 001.875-1.875V18.75h1.875a1.875 1.875 0 001.875-1.875V15a1.875 1.875 0 00-1.875-1.875h-1.875V11.25A1.875 1.875 0 0022.5 9.375h-1.875M6.563 9.375H3.75a1.875 1.875 0 00-1.875 1.875v9.375A1.875 1.875 0 003.75 22.5h2.813M11.526 18.5s3.143.786 4.715-1.571c1.573-2.358-.303-7.554 1.572-9.429-4.715 0-8.313 2.166-9.43 5.5-.785 2.359 0 4.715 3.143 5.5zM12.188 14.063a8.992 8.992 0 00-1.876 8.437","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    